import React, { useEffect, useState } from "react";
import { Dropdown, Form as BTForm, Row } from "react-bootstrap";
import Card from "src/components/Cards/Basic";
import FabPlateau from "src/components/UiComponents/Buttons/FabPlateau";
import IconButton from "src/components/IconButton";
import { dateFormatter, euroFormatter } from "src/global";
import {
  faAdd,
  faPencil as PencilIcon,
  faTrash as DeleteIcon,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useModal from "src/components/Modal/hooks/useModal";
import ConfirmDeleteDialog from "src/components/Modal/ConfirmDelete";
import EditPriceDialog from "././EditPriceDialog";
import CopyPricesDialog from "./CopyPricesDialog";
import { showErrorToast, showSuccessToast } from "src/components/Toasts";
import axios from "src/config/axios";
import useFilter from "src/global/useFilter";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import FilterResetButton from "src/components/UiComponents/Buttons/FilterResetButton";
import MultiSelectBox from "src/components/Forms/MultiSelectBox";
import { useTranslation } from "react-i18next";

const GeneralPriceSettingsPage = ({}) => {
  function handleEdit(price) {
    setSelectedPrice(price);
    toggleEdit();
  }

  function handleArchive(price) {
    setSelectedPrice(price);
    toggleArchive();
  }

  function handleCreate() {
    setSelectedPrice({});
    toggleEdit();
  }
  const [prices, setPrices] = useState([]);
  const [showCopy, setShowCopy] = useState(false);
  const [selectedPrice, setSelectedPrice] = useState({});
  const { isShow: showEdit, toggle: toggleEdit } = useModal();
  const { isShow: showArchive, toggle: toggleArchive } = useModal();
  const [seasons, setSeasons] = useState([]);
  const { pathname } = useLocation();
  const { filter, setFilter, resetFilter } = useFilter(pathname, {
    seasons: [],
    hide_past_seasons: true,
  });
  const [isFirstRender, setIsFirstRender] = useState(true);
  const { t } = useTranslation("dashboard");

  useEffect(() => {
    fetchSeasons();
  }, []);

  useEffect(() => {
    if (!isFirstRender) {
      fetchPrices();
    }

    setIsFirstRender(false);
  }, [filter]);

  const fetchSeasons = () => {
    axios
      .get(`/api/v1/seasons.json`)
      .then(function (response) {
        setFilter({
          ...filter,
          seasons: response.data.entries.map((season) => season.id),
        });
        setSeasons(response.data.entries);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const fetchPrices = () => {
    axios
      .get(`/api/v1/prices.json`, { params: filter })
      .then(function (response) {
        setPrices(response.data.entries);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const archive = (price) => {
    axios
      .delete(`/api/v1/prices/${price.id}.json`)
      .then(function () {
        fetchPrices();
      })
      .catch(function (error) {
        showErrorToast(error.response.data);
      });
  };

  const handleEdited = () => {
    showSuccessToast();
    fetchPrices();
  };

  function handleCopied(targetSeasonId) {
    setShowCopy(false);
    showSuccessToast();
    setFilter({
      ...filter,
      seasons: [targetSeasonId],
      hide_past_seasons: false,
    });
  }

  const handleDelete = () => {
    archive(selectedPrice);
    toggleArchive();
  };

  const header = (
    <div className="d-flex flex-wrap w-100 justify-content-between align-items-center">
      <span>{`Preise für Stellplätze (${prices.length ?? 0})`}</span>
      <FilterResetButton
        resetCallback={() => {
          resetFilter();
        }}
      />
    </div>
  );

  return (
    <>
      <Card title={header}>
        <div className="filter-container">
          <div className={"d-flex w-100 align-items-center flex-wrap"}>
            <div className={"mb-3 mb-sm-0 mr-3"}>
              <MultiSelectBox
                label={"Saisonen"}
                options={seasons.map((season) => {
                  return { name: season.name, value: season.id };
                })}
                selectedValues={filter.seasons}
                onChange={(seasons) =>
                  setFilter({ ...filter, seasons: seasons })
                }
              />
            </div>
          </div>
          <BTForm.Check
            className={"mr-3 mb-3"}
            type="checkbox"
            label="Vergangene Saisonen ausblenden"
            name="hide_past_seasons"
            value={filter.hide_past_seasons}
            checked={filter.hide_past_seasons}
            onChange={() =>
              setFilter({
                ...filter,
                hide_past_seasons: !filter.hide_past_seasons,
              })
            }
            id={"hide_past_seasons"}
          />
        </div>
        <div className="table-responsive">
          <div className="ui-table-container">
            <table
              className="table table-bordered"
              id="dataTable"
              width="100%"
              cellSpacing="0"
            >
              <thead>
                <tr>
                  <th>Kategorie</th>
                  <th>Saison</th>
                  <th>Von</th>
                  <th>Bis</th>
                  <th>Preis pro</th>
                  <th>Preis</th>
                  <th>Optionen</th>
                </tr>
              </thead>
              <tbody>
                {prices.map((price) => {
                  return (
                    <tr key={price.id}>
                      <td>{price.parking_slot_category.name}</td>
                      <td>{price.season.name}</td>
                      <td>
                        {price.season.from && dateFormatter(price.season.from)}
                      </td>
                      <td>
                        {price.season.to && dateFormatter(price.season.to)}
                      </td>
                      <td>
                        {price.formatted_price_unit}&nbsp;
                        {price.age_group && price.age_group.name}
                      </td>
                      <td>{price.price && euroFormatter(price.price)}</td>
                      <td>
                        <IconButton
                          className="mr-1 bg-transparent border-0 mr-3"
                          textColor="var(--primary)"
                          icon={PencilIcon}
                          onClick={() => handleEdit(price)}
                        />
                        <IconButton
                          className="mr-2 mr-3 bg-transparent border-0"
                          textColor="var(--danger)"
                          icon={DeleteIcon}
                          onClick={() => handleArchive(price)}
                        />
                      </td>
                    </tr>
                  );
                })}
                {prices.length === 0 && (
                  <tr>
                    <td>{t("common:components.table.noEntries")}</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        <Row className="justify-content-end mr-2 mt-5">
          <FabPlateau>
            <Dropdown drop="up">
              <Dropdown.Toggle
                id="new-price-dropdown"
                className="p-2 pl-3 pr-3"
                variant="primary"
              >
                {t("common:components.button.new")}
              </Dropdown.Toggle>
              <Dropdown.Menu alignRight>
                <Dropdown.Item onClick={handleCreate}>
                  {t("common:components.button.new")}
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => setShowCopy(true)}
                  disabled={seasons.length < 2}
                >
                  {t("settings.price_list.prices.copy_prices_dialog.title")}
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </FabPlateau>
        </Row>
      </Card>
      {showCopy && (
        <CopyPricesDialog
          seasons={seasons}
          handleClose={() => setShowCopy(false)}
          handleSuccess={handleCopied}
        />
      )}
      <EditPriceDialog
        show={showEdit}
        toggle={toggleEdit}
        price={selectedPrice}
        handleSuccess={handleEdited}
      />
      <ConfirmDeleteDialog
        show={showArchive}
        handleClose={toggleArchive}
        handleDelete={handleDelete}
      />
    </>
  );
};

export default GeneralPriceSettingsPage;
